import { ValidationObserver, ValidationProvider } from "vee-validate";
import imageToBase64 from 'image-to-base64/browser';
import firebase from 'firebase';

export default {
    name: "SharePhotoDlg",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            dialogSharePhoto: false,
            email: '',
            media: null,
            loading: false,
            attachments: []
        }
    },
    methods: {
        async shareMedia() {
            if(this.media?.image) {
                await this.sharePhotoByEmail(this.media.image)
            }

            if(this.media?.video) {
                await this.shareVideoByEmail(this.media.video)
            }
        },
        async sharePhotoByEmail(photo) {
            console.log("START SHARE PHOTO ", photo)
            this.loading = true;

            const photoBase64 = await imageToBase64(photo);

            this.attachments.push({
                filename: `Photo.png`,
                content: photoBase64,
                encoding: 'base64'
            });

            await firebase
                .firestore()
                .collection('email')
                .add({
                    to: this.email,
                    facilityId: this.$store.state.authModule.currentFacility,
                    message: {
                        subject: "Gallery Photo",
                        html: `Gallery Photo`,
                        attachments: this.attachments
                    }
                }).then(() => {
                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['SharePhotoDlg.SuccessSendingPhoto'],
                        type: "success"
                    });
                    this.close();
                }).catch((error) => {
                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['SharePhotoDlg.ErrorSendingPhoto'],
                        type: "error"
                    });
                    this.loading = false;
                })
        },
        async shareVideoByEmail(videoUrl) {
            this.loading = true;

            await firebase
              .firestore()
              .collection('email')
              .add({
                  to: this.email,
                  facilityId: this.$store.state.authModule.currentFacility,
                  message: {
                      subject: "Gallery Video",
                      html: `
                          <p>Click the link below to download the video:</p>
                          <a href="${videoUrl}" download>${videoUrl}</a>
                        `
                  }
              }).then((querySnapshot) => {
                  this.$toast.open({
                      message: this.$t('SharePhotoDlg.SuccessSendingVideo'),
                      type: "success"
                  });
                  this.close();
              }).catch((error) => {
                  this.$toast.open({
                      message: this.$t('SharePhotoDlg.ErrorSendingVideo'),
                      type: "error"
                  });
                  this.loading = false;
              })
        },
        open(media) {
            this.dialogSharePhoto = true;
            this.media = media;
        },
        close() {
            this.dialogSharePhoto = false;
            this.media = null;
            this.email = "";
            this.loading = false;
            this.attachments = [];
            this.$refs.observer.reset();
        }
    }
}